import React from 'react'
import { Redirect } from 'react-router-dom'
import GsuiteAuth from 'components/Auth/GsuiteAuth.jsx';

const Auth = (props) => (GsuiteAuth.isLoggedIn() ? props.children : <Redirect to={'/login'}/>)

export default Auth

